import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CarouselIndicators from 'JS/dxp/components/shared/CarouselIndicators.vue';
import ProductCarouselCard from 'JS/components/carousels/ProductCarouselCard.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { getPriceMode } from 'JS/types/Product';
import { IProductCarousel, IProductCarouselProduct } from 'JS/types/Carousel';
import { ListSliderElement, SlideChangeEvent } from 'JS/list-slider';
import { onMounted, ref } from 'vue';
import { useProductCarouselTracking } from 'JS/dxp/composables/product-carousel-tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredCarousel',
  props: {
    carousel: null
  },
  setup(__props: any) {

const props = __props as {
	carousel: IProductCarousel;
}



const slider = ref<ListSliderElement>();
const numSlides = ref(0);
const currentSlide = ref(0);

onMounted(() => {
	// We need to set up our carousel on load to populate our indicators
	numSlides.value = slider.value?.slideCount ?? 0;
	currentSlide.value = slider.value?.slide ?? 0;
});

function handleSlideChange(e: SlideChangeEvent) {
	const { toSlide, slideCount } = e.detail;
	currentSlide.value = toSlide;
	numSlides.value = slideCount;
}

function handleUpdateSlide(slide: number) {
	if (slider.value) {
		slider.value.slide = slide;
	}
}

///////GA Tracking///////
const intersectionObserverOptions = {
	root: null,
	rootMargin: '-150px', //Trigger once 150px of the carousel is in view
};

const { trackView, trackClick } = useProductCarouselTracking(() => ({
	type: props.carousel.carouselType,
	name: props.carousel.title,
	products: props.carousel.products.map(product => ({
		blainNumber: product.blainNumber,
		vendorBrand: product.vendorBrand,
		productName: product.name,
		price: product.price,
		belowMap: product.price.isBelowMAP,
		priceMode: getPriceMode(product.price)
	}))
}));


function trackViewHelper() {
	//GA Tracking
	trackView();

	//Epsilon Tracking (Decided that when the carousel is in view, send off all possible impressions.)
	const adIDs = props.carousel.products.map((prod) => prod.adID);
	const uniqueAdIDs = [...new Set(adIDs)];

	navigator.sendBeacon('/event/a/sponsored-ad-impression', JSON.stringify(uniqueAdIDs));
}

function trackClickHelper(product: IProductCarouselProduct, index: number) {
	//GA Tracking
	trackClick({
		blainNumber: product.blainNumber,
		price: product.price,
		brand: product.vendorBrand,
		name: product.name,
	}, index);

	//Epsilon Tracking
	return navigator.sendBeacon('/event/a/sponsored-ad-click', JSON.stringify(product.adID));
}


return { __sfc: true,props, slider, numSlides, currentSlide, handleSlideChange, handleUpdateSlide, intersectionObserverOptions, trackView, trackClick, trackViewHelper, trackClickHelper, CarouselArrowButton, CarouselIndicators, ProductCarouselCard, VIntersectionObserver }
}

})